import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { logDataToDatadog } from '#configuration/datadog/logging.ts';
import { prepareHeaders } from '#configuration/tokenHandling/prepareHeaders.ts';
import { rtkAppRetry } from '#store/apiRetry.ts';

export const TAGS = {
    ORDERS: 'ORDERS',
    TOURS: 'TOURS',
    DOCUMENTS: 'DOCUMENTS',
    DRIVERS: 'DRIVERS',
    VEHICLES: 'VEHICLES',
};

const baseUrl = import.meta.env.VITE_ORDERCOM_API_PROXY;
const v2BaseUrl = baseUrl.endsWith('/v2') ? baseUrl : `${baseUrl.replace(/\/$/, '')}/v2`;

const customFetchBaseQuery = fetchBaseQuery({
    baseUrl: v2BaseUrl,
    credentials: 'include',
    mode: 'cors',
    prepareHeaders,
});
const customFetchBaseQueryWithRetry = rtkAppRetry(customFetchBaseQuery);

const customFetchBaseQueryWithDatadog: typeof customFetchBaseQuery = async (args, api, extraOptions) => {
    if (api.type === 'mutation') {
        logDataToDatadog(`[feature/mutation] ${api.endpoint}`);
    }
    return customFetchBaseQueryWithRetry(args, api, extraOptions);
};

export const apiV2Root = createApi({
    tagTypes: Object.keys(TAGS),
    reducerPath: 'apiV2',
    baseQuery: customFetchBaseQueryWithDatadog,
    endpoints: () => ({}),
});
